import { Injectable } from '@angular/core';
import { GuidGeneratorService, StorageService } from '@shared';
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import { SecureStorage, SecureStorageObject } from '@awesome-cordova-plugins/secure-storage/ngx';
import { Platform } from '@ionic/angular';

@Injectable()
export class DeviceIdProvider {
	private secureStorageObject: SecureStorageObject | null = null;

	public constructor(
		private storageService: StorageService,
		private secureStorage: SecureStorage,
		private platform: Platform,
	) { }

	public async setDeviceId(): Promise<void> {
		const storedDeviceId = await this.storageService.get('deviceId');

		if (!storedDeviceId) {
			const deviceId = await this.generateDeviceId();
			await this.storageService.set('deviceId', deviceId);
		}
	}

	public async generateDeviceId(): Promise<string> {
		await this.platform.ready(); // Ensure Cordova plugins are loaded

		const platform = Capacitor.getPlatform();

		if (platform === 'ios') {
			if (!this.secureStorageObject) {
				this.secureStorageObject = await this.secureStorage.create('qlstore');
			}

			try {
				const existing = await this.secureStorageObject.get('persistent_device_id');
				return existing;
			} catch (error) {
				console.error('[SecureStorage] Failed to get device ID:', error);
				const deviceIdInfo = await Device.getId();
				await this.secureStorageObject.set('persistent_device_id', deviceIdInfo.identifier);
				return deviceIdInfo.identifier;
			}
		}

		const deviceIdInfo = await Device.getId();
		return deviceIdInfo.identifier;
	}

	public async getDeviceId(): Promise<string> {
		const storedDeviceId: string = await this.storageService.get('deviceId');

		if (storedDeviceId) {
			return storedDeviceId;
		}

		await this.setDeviceId();
		return await this.storageService.get('deviceId');
	}
}
